import * as types from '../constants/cidraActions';
import {
  doLoginFailure,
  doLogout,
  doSetInitialTempCode,
  setServerState,
  startLoading,
  doStartAuthSessionAndRestoreAuthState
} from './shared';
import { AuthenticationProtocols } from '../constants/clientProtocols';
import { decideNextStep } from './decideNextStep';

export function doGetResumeAuthFlowToken() {
  return function(dispatch, getState) {
    const {
      initialUsername,
      resumeAuthFlowTokenUrl,
    } = getState().login;
    dispatch(startLoading() );
    if (initialUsername && resumeAuthFlowTokenUrl) {
      return fetch(resumeAuthFlowTokenUrl, { method: 'get', credentials: 'include', }).then(response => {
        if (response.ok && response.headers.get('Content-Type').indexOf('application/json') >= 0) {
          return response;
        }
        else {
          throw new Error('Response was not ok');
        }
      }).then(
        response => response.json()
      ).then(responseJson => {
        if (responseJson.status === 'RESUME_AUTH_FLOW') {
          dispatch(setResumeAuthFlowToken(responseJson.resumeAuthFlowToken) );
        }
        else if (responseJson.status === 'ERROR') {
          dispatch(redirectToErrorPage() );
          window.location.href = responseJson.errorUrl;
        }
        else if (responseJson.status === 'REDIRECT_TO_SP') {
          dispatch(doSetWsFedResponse(
            responseJson.wa, responseJson.wctx,
            responseJson.wresult, responseJson.wsFedUrl) );
        }
        else if (responseJson.status === 'FORCE_REAUTHENTICATION') {
          dispatch(doLogout() );
        }
        else {
          throw new Error('Unsupported status');
        }
      }).catch( () => {
        dispatch(doLogout() );
      });
    }
    else {
      dispatch(doLogout() );
    }
  };
}

export function setResumeAuthFlowToken(resumeAuthFlowToken) {
  return {
    type: types.SET_RESUME_AUTH_FLOW_TOKEN,
    resumeAuthFlowToken,
  };
}

export function doStartResumeAuthFlow() {
  return doStartAuthSessionAndRestoreAuthState(
    setRestoreAuthSessionFromIdpSessionStarted, doRestoreAuthStateFromIdpSession);
}

/**
 * Restore the authentication state from the resumeAuthFlowToken which is created based on an existing IdP session.
 */
export function doRestoreAuthStateFromIdpSession() {
  return function(dispatch, getState) {
    const {
      session, authClient, oneSignSessionId, resumeAuthFlowToken,
    } = getState().login;
    const { AuthResponseAuthErrorContinued, AuthResumeAuthFlow, } = AuthenticationProtocols;
    const encryptedToken = session.encryptSecret(resumeAuthFlowToken);
    const resumeAuthFlow = new AuthResumeAuthFlow(oneSignSessionId, encryptedToken.value);
    return authClient.sendRequest(resumeAuthFlow).then(response => {
      const serverState = response.message;
      dispatch(setServerState(serverState) );
      if (serverState.errorCode && serverState.responseType !== AuthResponseAuthErrorContinued) {
        dispatch(doLogout() );
        dispatch(doLoginFailure(serverState.errorCode) );
      }
      else {
        dispatch(doRestoreAuthSessionFromIdpSessionSuccess() );
        dispatch(doSetInitialTempCode(serverState.temporaryCodeAllowed && serverState.temporaryCodeAvailable) );
        dispatch(decideNextStep(serverState, false) );
      }
    }).catch(ex => {
      dispatch(doLogout() );
      dispatch(doLoginFailure(ex) );
    });
  };
}

export function setRestoreAuthSessionFromIdpSessionStarted() {
  return { type: types.RESTORE_AUTH_SESSION_FROM_IDP_SESSION_STARTED, };
}

export function doRestoreAuthSessionFromIdpSessionSuccess() {
  return { type: types.RESTORE_AUTH_SESSION_FROM_IDP_SESSION_SUCCESS, };
}

export function redirectToErrorPage() {
  return { type: types.REDIRECT_TO_ERROR_PAGE, };
}

export function doSetWsFedResponse(wa, wctx, wresult, wsFedUrl) {
  return {
    type: types.SET_WS_FED_RESPONSE,
    wa: wa,
    wctx: wctx,
    wresult: wresult,
    wsFedUrl: wsFedUrl,
  };
}
